import { useState } from 'react';
import { useLang } from '../context/LanguageContext';

const MeasureStep = ({ value, onSave }) => {
  const { t } = useLang();
  const [heightUnit, setHeightUnit] = useState(value?.heightUnit || 'ft');
  const [weightUnit, setWeightUnit] = useState(value?.weightUnit || 'lbs');
  const [heightFt, setHeightFt] = useState(value?.heightFt || '');
  const [heightIn, setHeightIn] = useState(value?.heightIn || '');
  const [heightCm, setHeightCm] = useState(value?.heightCm || '');
  const [weight, setWeight] = useState(value?.weight || '');

  const canContinue = () => {
    const w = parseFloat(weight);
    if (!w || w <= 0) return false;
    if (heightUnit === 'ft') return parseFloat(heightFt) > 0;
    return parseFloat(heightCm) > 0;
  };

  const handleContinue = () => {
    if (!canContinue()) return;
    onSave({
      heightUnit,
      weightUnit,
      heightFt,
      heightIn,
      heightCm,
      weight
    });
  };

  const Toggle = ({ options, value: v, onChange }) => (
    <div className="inline-flex bg-[#1a1b1e] border border-[#2a2b2f] rounded-sm p-1">
      {options.map((o) => (
        <button
          key={o}
          onClick={() => onChange(o)}
          className={`px-4 py-1.5 text-sm font-semibold rounded-sm transition-colors ${
            v === o ? 'bg-[#ff4e15] text-white' : 'text-white/60 hover:text-white'
          }`}
        >
          {o.toUpperCase()}
        </button>
      ))}
    </div>
  );

  return (
    <div className="max-w-md mx-auto">
      <div className="space-y-8">
        <div>
          <div className="flex items-center justify-between mb-3">
            <label className="text-sm font-semibold text-white/80 uppercase tracking-wide">{t('height')}</label>
            <Toggle options={['ft', 'cm']} value={heightUnit} onChange={setHeightUnit} />
          </div>
          {heightUnit === 'ft' ? (
            <div className="grid grid-cols-2 gap-3">
              <div className="relative">
                <input
                  type="number"
                  value={heightFt}
                  onChange={(e) => setHeightFt(e.target.value)}
                  placeholder="ft"
                  className="w-full px-4 py-4 bg-[#1a1b1e] border border-[#2a2b2f] focus:border-[#ff4e15] outline-none rounded-sm text-white text-lg font-medium transition-colors"
                />
                <span className="absolute right-4 top-1/2 -translate-y-1/2 text-white/40 text-sm">ft</span>
              </div>
              <div className="relative">
                <input
                  type="number"
                  value={heightIn}
                  onChange={(e) => setHeightIn(e.target.value)}
                  placeholder="in"
                  className="w-full px-4 py-4 bg-[#1a1b1e] border border-[#2a2b2f] focus:border-[#ff4e15] outline-none rounded-sm text-white text-lg font-medium transition-colors"
                />
                <span className="absolute right-4 top-1/2 -translate-y-1/2 text-white/40 text-sm">in</span>
              </div>
            </div>
          ) : (
            <div className="relative">
              <input
                type="number"
                value={heightCm}
                onChange={(e) => setHeightCm(e.target.value)}
                placeholder="cm"
                className="w-full px-4 py-4 bg-[#1a1b1e] border border-[#2a2b2f] focus:border-[#ff4e15] outline-none rounded-sm text-white text-lg font-medium transition-colors"
              />
              <span className="absolute right-4 top-1/2 -translate-y-1/2 text-white/40 text-sm">cm</span>
            </div>
          )}
        </div>

        <div>
          <div className="flex items-center justify-between mb-3">
            <label className="text-sm font-semibold text-white/80 uppercase tracking-wide">{t('weight')}</label>
            <Toggle options={['lbs', 'kg']} value={weightUnit} onChange={setWeightUnit} />
          </div>
          <div className="relative">
            <input
              type="number"
              value={weight}
              onChange={(e) => setWeight(e.target.value)}
              placeholder={weightUnit}
              className="w-full px-4 py-4 bg-[#1a1b1e] border border-[#2a2b2f] focus:border-[#ff4e15] outline-none rounded-sm text-white text-lg font-medium transition-colors"
            />
            <span className="absolute right-4 top-1/2 -translate-y-1/2 text-white/40 text-sm">{weightUnit}</span>
          </div>
        </div>
      </div>

      <button
        onClick={handleContinue}
        disabled={!canContinue()}
        className={`mt-8 w-full py-3.5 rounded-sm font-bold uppercase tracking-wide transition-all ${
          !canContinue()
            ? 'bg-[#2a2b2f] text-white/40 cursor-not-allowed'
            : 'bg-[#ff4e15] hover:bg-[#ff6033] text-white pulse-orange'
        }`}
        data-testid="measure-continue-btn"
      >
        {t('continue')}
      </button>
    </div>
  );
};

export default MeasureStep;
